import Component from "../abstracts/Component";

export default class RowTwinComponent extends Component {
  get SELECTORS() {
    return {
      main: '.row--twin',
      observe: '.observe',
      twin: '.c-twin',
      card: 'widget-wrapper--card'
    }
  }

  get CONF() {
    return {
      margin: Math.floor(window.outerHeight - 300)
    }
  }

  get CLASSES() {
    return {
      inViewport: 'in-viewport'
    }
  }

  constructor() {
    super()
  }

  bindScroll() {
    const rowTwin = document.querySelectorAll(this.SELECTORS.main);

    rowTwin.forEach(el => {
      const observables = el.querySelectorAll(this.SELECTORS.observe);

      if (observables) {
        observables.forEach(obs => {
          if (this.isVisible(obs)) obs.classList.add(this.CLASSES.inViewport);
        });

        $(window).on(`scroll.rowtwin`, () => {
          observables.forEach(obs => {
            if (this.isVisible(obs)) obs.classList.add(this.CLASSES.inViewport);
          });
        });
      }

    });
  }

  isVisible(el) {
    const rect = el.getBoundingClientRect();
    return rect.top <= this.CONF.margin;
  }

  enableLinkOnPseudoElement() {
    if(this.$matchMedia('sm', null)) {
      let twin = document.querySelectorAll(this.SELECTORS.twin);
      twin.forEach(el => {
        let cards = el.getElementsByClassName(this.SELECTORS.card);
        for(let card of cards) {
          card.classList.add("after-link");
        }
      });
    }
  }

  render () {
    if (document.querySelector(this.SELECTORS.main)){
      this.bindScroll();
      this.enableLinkOnPseudoElement();
    }
  }
}
